import { merge } from 'lodash';
import { environment as baseEnvironment } from '../environment.base';

export const environment = merge(baseEnvironment, {});



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts